module.exports = __webpack_public_path__ + "static/media/benchmark_active.8166d83d.svg";